import { User, UsersPayload } from "../../../generated";
import { Maybe } from '../../../generated/index';

export interface UserState {
  usersData: UsersPayload["users"];
  currentUser: Maybe<User>;
  isVerifyEmail: boolean;
  pageValue: number
  searchData: UsersPayload["users"];
  isEmailAndPasswordVerified: boolean;
  isReminderSent: boolean;
}

export const userInitialState: UserState = {
  usersData: null,
  currentUser: null,
  searchData: null,
  isVerifyEmail: false,
  pageValue: 0,
  isEmailAndPasswordVerified: false,
  isReminderSent: false,
}

export enum UserActionType {
  SET_USERS_DATA = 'setUsersData',
  SET_CURRENT_USER = 'setCurrentUser',
  SET_SEARCH_DATA = 'setSearchData',
  SET_IS_VERIFY_EMAIL = "setIsVerifyEmail",
  SET_PAGE_VALUE = "setPageValue",
  SET_IS_EMAIL_AND_PASSWORD_VERIFIED = "setIsEmailAndPasswordVerified",
  SET_IS_REMINDER_SENT = "setIsReminderSent",
}

export type UserAction =
  | { type: UserActionType.SET_USERS_DATA, usersData: UsersPayload["users"] }
  | { type: UserActionType.SET_CURRENT_USER, currentUser: Maybe<User> }
  | { type: UserActionType.SET_SEARCH_DATA, searchData: UsersPayload["users"] }
  | { type: UserActionType.SET_IS_VERIFY_EMAIL, isVerifyEmail: boolean }
  | { type: UserActionType.SET_PAGE_VALUE, pageValue: number }
  | { type: UserActionType.SET_IS_EMAIL_AND_PASSWORD_VERIFIED, isEmailAndPasswordVerified: boolean }
  | { type: UserActionType.SET_IS_REMINDER_SENT, isReminderSent: boolean }

export const userReducer = (state: UserState, action: UserAction): UserState => {
  switch (action.type) {
    case UserActionType.SET_USERS_DATA:
      return {
        ...state,
        usersData: action.usersData
      }

    case UserActionType.SET_CURRENT_USER:
      return {
        ...state,
        currentUser: action.currentUser
      }

    case UserActionType.SET_SEARCH_DATA:
      return {
        ...state,
        searchData: action.searchData
      }

    case UserActionType.SET_IS_VERIFY_EMAIL:
      return {
        ...state,
        isVerifyEmail: action.isVerifyEmail
      }

    case UserActionType.SET_PAGE_VALUE:
      return {
        ...state,
        pageValue: action.pageValue
      }

    case UserActionType.SET_IS_EMAIL_AND_PASSWORD_VERIFIED:
      return {
        ...state,
        isEmailAndPasswordVerified: action.isEmailAndPasswordVerified
      }

    case UserActionType.SET_IS_REMINDER_SENT:
      return {
        ...state,
        isReminderSent: action.isReminderSent
      }

    default:
      return state
  }
}
